import { env } from '@/src/env'
import { useSessionStore } from '@/src/hooks/use_session_store'
import { Divider } from '@chakra-ui/react'
import { Inbox, type Notification } from '@novu/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  NOTIFICATION_INBOX_APPEARANCE,
  NOTIFICATION_INBOX_LOCALIZATION_DE,
  NOTIFICATION_INBOX_LOCALIZATION_EN,
} from './NotificationInbox.consts'
import { useNotificationTabs } from './useNotificationTabs.hook'

const closeInboxPopover = () => {
  document.body.dispatchEvent(new MouseEvent('click', { bubbles: true }))
}

export const NotificationInbox = () => {
  const { t, i18n } = useTranslation()
  const { user } = useSessionStore()
  const navigate = useNavigate()
  const tabs = useNotificationTabs()

  const applicationIdentifier = env.novuApplicationId

  if (!user?.pgId) {
    return null
  }

  const subscriberId = String(user.pgId)
  const localization = i18n.language === 'de' ? NOTIFICATION_INBOX_LOCALIZATION_DE : NOTIFICATION_INBOX_LOCALIZATION_EN

  const handleNotificationClick = (n: Notification) => {
    if (!!n.data && 'redirectUrl' in n.data && typeof n.data.redirectUrl === 'string') {
      navigate(n.data.redirectUrl)
    }
    closeInboxPopover()
  }

  return (
    <>
      <Divider orientation='vertical' height='30px' ml='8px' mr='8px' />
      <Inbox
        applicationIdentifier={applicationIdentifier}
        subscriberId={subscriberId}
        backendUrl={env.novuBackendUrl}
        tabs={tabs.map(tab => ({ label: t(tab.labelKey), value: tab.value }))}
        socketUrl={env.novuBackendSocketUrl}
        onNotificationClick={handleNotificationClick}
        onPrimaryActionClick={handleNotificationClick}
        localization={localization}
        appearance={NOTIFICATION_INBOX_APPEARANCE}
      />
    </>
  )
}
